import W from "moment";
import { OrderFormat as p, DayOfWeek as f, IntervalType as l, IntervalState as O } from "@ancon/wildcat-types";
import H from "../shared/isWithinFlag.mjs";
import T from "../shared/generateId.mjs";
import "react";
import I from "../time/getTimeSpanParts.mjs";
import M from "../date/createLocalTimezoneMoment.mjs";
import h from "../date/convertToLocalTimezone.mjs";
import "../date/getTimezoneUtcOffsetDifference.mjs";
const k = [
  { id: p.EatIn, name: "eatIn" },
  { id: p.TakeAway, name: "takeaway" },
  { id: p.TableOrder, name: "tableOrder" },
  { id: p.Delivery, name: "delivery" },
  { id: p.BoxPickup, name: "boxPickup" }
];
function Y(r) {
  const s = h(
    W(r).utc()
  ).startOf("day"), e = [];
  for (let t = 0; t < 7; t += 1)
    e.push(s.clone().add(t, "day"));
  return e;
}
function x(r) {
  return [...r].sort((s, e) => s.isoWeekday() - e.isoWeekday());
}
function v(r, s) {
  const e = I(r.from), t = I(r.duration);
  if (r.type === l.Normal) {
    const n = s.clone().add(e.hours, "hour").add(e.minutes, "minute"), a = n.clone().add(t);
    return {
      id: r.id,
      start: n.format("YYYY-MM-DDTHH:mm:ss"),
      end: a.format("YYYY-MM-DDTHH:mm:ss")
    };
  }
  if (r.type === l.Exception) {
    const n = M(r.periodFrom), a = M(r.periodTo);
    if (s.isBetween(n, a, void 0, "[]")) {
      const o = s.clone().add(e.hours, "hour").add(e.minutes, "minute"), i = o.clone().add(t);
      return {
        id: r.id,
        start: o.format("YYYY-MM-DDTHH:mm:ss"),
        end: i.format("YYYY-MM-DDTHH:mm:ss"),
        reason: r.reason
      };
    }
    return null;
  }
  throw new Error("Invalid interval type");
}
function D(r, s, e) {
  const t = {
    [f.Monday]: 1,
    [f.Tuesday]: 2,
    [f.Wednesday]: 3,
    [f.Thursday]: 4,
    [f.Friday]: 5,
    [f.Saturday]: 6,
    [f.Sunday]: 7,
    [f.Everyday]: null
  };
  for (let n = 0; n < s.length; n += 1) {
    const a = s[n], o = a.isoWeekday(), i = r.dayOfWeek, m = (t[i] ?? null) === o || i === f.Everyday;
    if (e[o] || (e[o] = {
      isoWeekday: o,
      key: "",
      open: [],
      adjusted: [],
      closed: []
    }), m) {
      const d = v(r, a);
      d && (e[o].key += d.id, r.type === l.Normal && r.state === O.Opened ? e[o].open.push(d) : r.type === l.Normal && r.state === O.Closed ? e[o].closed.push(d) : r.type === l.Exception && r.state === O.Opened ? e[o].adjusted.push(d) : r.type === l.Exception && r.state === O.Closed && e[o].closed.push(d));
    }
  }
}
function E(r) {
  switch (r.type) {
    case l.Exception:
      return T("interval-exception");
    case l.Normal:
      return T("interval-normal");
    default:
      return T("interval-unknown");
  }
}
function S(r) {
  const s = r.reduce((e, t) => (k.forEach((n) => {
    H(n.id, t.orderFormats) && (e[n.id] || (e[n.id] = {
      orderFormat: n,
      intervals: []
    }), e[n.id].intervals.push(
      ...t.intervals.sort(
        (a, o) => a.dayOfWeek - o.dayOfWeek
      )
    ));
  }), e), {});
  return Object.values(s);
}
function w(r, s) {
  const e = s.reduce((t, n) => n <= r ? t + 1 : t, 0);
  return r - e;
}
function j(r) {
  const { mergedTables: s } = r.reduce(
    (e, t, n) => {
      const a = e.mergedTables.findIndex(
        (o) => o !== t && !o.orderFormats.some(
          (i) => t.orderFormats.some(
            (u) => u.id === i.id
          )
        ) && o.openingHours.every(
          (i) => t.openingHours.some((u) => u.key === i.key)
        ) && t.openingHours.every(
          (i) => o.openingHours.some((u) => u.key === i.key)
        )
      );
      if (a >= 0) {
        if (e.skipOrderFormats.some(
          (d) => t.orderFormats.every((y) => y.id === d.id)
        ))
          return e;
        const i = e.mergedTables[a];
        e.mergedTables.splice(a, 1, {
          ...i,
          orderFormats: [...t.orderFormats, ...i.orderFormats]
        });
        const u = i.orderFormats.filter(
          (d) => !e.skipOrderFormats.some((y) => y.id === d.id)
        );
        u.length > 0 && e.skipOrderFormats.push(...u);
        const m = w(n, [...e.removedIndexes]);
        return e.mergedTables.splice(m, 1), e.removedIndexes.push(n), e;
      }
      return e;
    },
    { mergedTables: [...r], removedIndexes: [], skipOrderFormats: [] }
  );
  return s;
}
function N(r) {
  return r.map((s) => ({
    ...s,
    intervals: s.intervals.map((e) => ({
      ...e,
      id: E(e)
    }))
  }));
}
function q(r, s) {
  const e = S(
    N(r.serviceDateTimes)
  ), t = Y(s), n = x(t), a = e.reduce(
    (m, d) => (m[d.orderFormat.id] || (m[d.orderFormat.id] = {}), d.intervals.reduce((y, c) => (D(c, n, y), y), m[d.orderFormat.id]), m),
    {}
  ), o = {
    [p.EatIn]: k[0],
    [p.TakeAway]: k[1],
    [p.TableOrder]: k[2],
    [p.Delivery]: k[3],
    [p.BoxPickup]: k[4]
  }, i = Object.entries(
    a
  ).map(([m, d]) => ({
    orderFormats: [o[Number(m)]],
    openingHours: Object.entries(d).map(
      ([y, c]) => ({
        isoWeekday: Number(y),
        key: c.key,
        open: c.open.sort(
          (g, F) => g.start.localeCompare(F.start)
        ),
        adjusted: c.adjusted.sort(
          (g, F) => g.start.localeCompare(F.start)
        ),
        closed: c.closed.sort(
          (g, F) => g.start.localeCompare(F.start)
        )
      })
    )
  }));
  return j(i).sort(
    (m, d) => m.orderFormats[0].id - d.orderFormats[0].id
  );
}
export {
  q as default
};
